import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { debugLog, errorLog } from '../utils/debug';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Silently checks user subscription status and redirects if invalid
 * @param {Object} currentUser - The current authenticated user
 * @param {Function} navigate - React Router navigate function
 * @returns {Promise<boolean>} - True if subscription is valid, false if invalid
 */
export const checkSubscriptionSilently = async (currentUser, navigate) => {
  if (!currentUser) return false;
  
  try {
    const { getFirestore, doc, getDoc } = await import('firebase/firestore');
    const db = getFirestore();
    const userDocRef = doc(db, 'users', currentUser.uid);
    const userDoc = await getDoc(userDocRef);
    
    if (!userDoc.exists()) {
      debugLog('📭 User document not found, redirecting to expired subscription');
      navigate('/expiredsub', { replace: true });
      return false;
    }
    
    const userData = userDoc.data();
    const stripeSubscriptionStatus = userData.stripe_subscription_status;
    
    debugLog('🔍 Silent subscription check:', {
      uid: currentUser.uid,
      stripe_subscription_status: stripeSubscriptionStatus
    });
    
    // Check if subscription is active or trialing
    if (stripeSubscriptionStatus !== 'active' && stripeSubscriptionStatus !== 'trialing') {
      debugLog('❌ Invalid subscription status:', stripeSubscriptionStatus);
      navigate('/expiredsub', { replace: true });
      return false;
    }
    
    debugLog('✅ Subscription valid');
    return true;
    
  } catch (error) {
    errorLog('❌ Error checking subscription:', error);
    // In case of error, assume no valid subscription for security
    navigate('/expiredsub', { replace: true });
    return false;
  }
};
